<template>
  <v-dialog :value="value" max-width="500px" persistent>
    <v-card flat dense>
      <v-card-title>
        <p class="ma-0">
          {{ $t('ORDERS.LIST.TITLE_PREFIX') }}
          <strong>{{ $t('ORDERS.ITEM') }}</strong>
        </p>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-subtitle>
        {{ $t('ORDERS.LIST.SUBTITLE_PREFIX') }}
        <strong>{{ $t('ORDERS.ITEM') }}</strong>
      </v-card-subtitle>

      <v-card-text>
        <business-order-action-list v-model="selected" />
      </v-card-text>
      <v-card-actions>
        <v-btn outlined depressed large color="grey" @click.prevent="close">
          {{ $t('BUTTON.CANCEL') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="selected === undefined"
          depressed
          color="primary"
          large
          @click.prevent="push()"
        >
          {{ $t('BUTTON.CREATE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { BUSINESS, INTERNAL, REPETITIVE_BUSINESS } from './../common/order-types';
import BusinessOrderActionList from './BusinessOrderActionList.vue';

const routes = {
  [BUSINESS]: 'business-order.create',
  [INTERNAL]: 'internal-order.create',
  [REPETITIVE_BUSINESS]: 'business-order-repetitive.create'
};

export default {
  name: 'CreateBusinessOrderPopup',

  components: { BusinessOrderActionList },

  props: {
    value: {
      type: Boolean,
      required: true
    },
    companyId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      selected: undefined
    };
  },

  methods: {
    close() {
      this.$emit('input', false);
    },
    push() {
      this.$router.push({
        name: routes[this.selected],
        params: { companyId: this.companyId }
      });
    }
  }
};
</script>
